import { useTranslation } from 'react-i18next'
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogFooter,
  AlertDialogTitle,
  AlertDialogDescription,
  AlertDialogAction,
  AlertDialogCancel,
} from '../ui/alert-dialog'

interface SavePlanConfirmDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  /** Week numbers whose diary workouts will be regenerated (empty = no diary impact). */
  affectedWeeks: number[]
  saving: boolean
  onConfirm: () => void
}

/**
 * Warns before saving an active plan: planned (not-completed) workouts in the
 * changed weeks are removed and recreated, completed ones are kept.
 */
export function SavePlanConfirmDialog({
  open,
  onOpenChange,
  affectedWeeks,
  saving,
  onConfirm,
}: SavePlanConfirmDialogProps) {
  const { t } = useTranslation()
  const hasImpact = affectedWeeks.length > 0

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{t('trainingPlans.builder.confirm.title')}</AlertDialogTitle>
          <AlertDialogDescription>
            {hasImpact
              ? t('trainingPlans.builder.confirm.body')
              : t('trainingPlans.builder.confirm.noChanges')}
          </AlertDialogDescription>
        </AlertDialogHeader>
        {hasImpact && (
          <p className="text-sm font-medium">
            {t('trainingPlans.builder.confirm.weeksAffected', { weeks: affectedWeeks.join(', ') })}
          </p>
        )}
        <AlertDialogFooter>
          <AlertDialogCancel disabled={saving}>
            {t('trainingPlans.builder.confirm.cancel')}
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={(e) => {
              e.preventDefault()
              onConfirm()
            }}
            disabled={saving}
          >
            {saving ? t('common.saving') : t('trainingPlans.builder.confirm.confirm')}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
